import {
  SET_CURRENT_CAMPAIGN
} from './mutation-types'

export default {
  [SET_CURRENT_CAMPAIGN]: (state, { campaign }) => {
    state.currentCampaign = campaign
  }
}
